"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioToJSON = exports.AudioFromJSONTyped = exports.AudioFromJSON = exports.instanceOfAudio = void 0;
var runtime_1 = require("../runtime");
var Asset_1 = require("./Asset");
var AudioCreationProperties_1 = require("./AudioCreationProperties");
var AudioFileType_1 = require("./AudioFileType");
var AudioType_1 = require("./AudioType");
/**
 * Check if a given object implements the Audio interface.
 */
function instanceOfAudio(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAudio = instanceOfAudio;
function AudioFromJSON(json) {
    return AudioFromJSONTyped(json, false);
}
exports.AudioFromJSON = AudioFromJSON;
function AudioFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return __assign(__assign({}, (0, Asset_1.AssetFromJSONTyped)(json, ignoreDiscriminator)), { 'audioType': !(0, runtime_1.exists)(json, 'audio_type') ? undefined : (0, AudioType_1.AudioTypeFromJSON)(json['audio_type']), 'durationMs': !(0, runtime_1.exists)(json, 'duration_ms') ? undefined : json['duration_ms'], 'fileType': !(0, runtime_1.exists)(json, 'file_type') ? undefined : (0, AudioFileType_1.AudioFileTypeFromJSON)(json['file_type']), 'audioCreationProperties': !(0, runtime_1.exists)(json, 'audio_creation_properties') ? undefined : (0, AudioCreationProperties_1.AudioCreationPropertiesFromJSON)(json['audio_creation_properties']) });
}
exports.AudioFromJSONTyped = AudioFromJSONTyped;
function AudioToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return __assign(__assign({}, (0, Asset_1.AssetToJSON)(value)), { 'audio_type': (0, AudioType_1.AudioTypeToJSON)(value.audioType), 'duration_ms': value.durationMs, 'file_type': (0, AudioFileType_1.AudioFileTypeToJSON)(value.fileType), 'audio_creation_properties': (0, AudioCreationProperties_1.AudioCreationPropertiesToJSON)(value.audioCreationProperties) });
}
exports.AudioToJSON = AudioToJSON;
